export default "__VITE_ASSET__CMuz1U9G__"